import React, { useEffect, useRef, useState } from "react";
import {
  setRecomandModal,
  setSelectedAd,
  setTooltipOpen,
} from "../../../redux/slices/LcaSlice";
import { Button, Spinner } from "reactstrap";
import { FaUser } from "react-icons/fa";
import { MdGroups } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import "./LcaCards.css";
import "moment-timezone/builds/moment-timezone-with-data";
import { UncontrolledTooltip } from "reactstrap";
import { BsInfoCircleFill } from "react-icons/bs";
import {
  checkExisting,
  handleActionClick,
  setActionType,
  setIsChatModalOpen,
  setSampleAd,
  setSearchPopUp,
  setShowCallDialog,
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { toast } from "react-toastify";
import { initiateCall } from "../Data";

const LcaActionButtons = ({
  ad,
  handleIndiviualCall,
  toggleEvents,
  toggleQuestions,
  openOfferModal,
  handleSkip,
  buttonRef,
  tooltipRef,
  timeLeft,
  questionsVisible,
  eventsVisible,
}) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { sampleAd, generatedNeedId } = useSelector((state) => state.searchBar);
  const { gottonData, tooltipOpen, recomandModal } = useSelector(
    (state) => state.lcAds
  );
  const [checkExistingNeed, setCheckExistingNeed] = useState(false);
  const isAdmin = user && user.Role === "admin";
  const isVendor = user?.Role === "provider";
  const [phoneButton, setPhoneButton] = useState("Show Phone Number");

  useEffect(() => {
    if (ad.Id === generatedNeedId) {
      setPhoneButton(`${ad?.Phone || 0} Ext# ${ad.dialExtension || 0}`);
    }
  }, [generatedNeedId, sampleAd]);

  const isAdInMyOffers = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.includes(user?.UserID);
  };

  const isAlreadyGotton = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.length >= 5;
  };

  const handleRecomend = (event, ad) => {
    event.stopPropagation();
    dispatch(setSelectedAd(ad));
    dispatch(setRecomandModal(true));
  };

  const handleAction = async (event, action) => {
    event.stopPropagation();
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));

    // If user is admin or vendor, handle action directly
    if (isAdmin || isVendor) {
      setPhoneButton(`${ad?.Phone || 0} Ext# ${ad.dialExtension || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (action === "TEXT") {
        console.log(action, "action");
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad.websiteLink, "_blank");
      }
      return;
    }

    // For non-admin/non-vendor users, check if the need exists
    let needExists = false;
    setCheckExistingNeed(true);
    if (islogin) {
      const constructedTitle = ad?.Title + " (Auto Generated)";
      const checkForm = {
        Title: constructedTitle,
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }

    // If need exists, handle the action
    if (needExists) {
      setPhoneButton(`${ad?.Phone || 0} Ext# ${ad.dialExtension || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (action === "TEXT") {
        console.log(action, "action");
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad.websiteLink, "_blank");
      }
      setCheckExistingNeed(false);
      return;
    }
    if (islogin) {
      const actionForm = {
        userId: user.UserID,
        postId: ad.Id,
        postType: 1,
        clickType: action === "CALL" ? 1 : action === "TEXT" ? 2 : 3,
        createdBy: user.UserID,
      };
      dispatch(handleActionClick(actionForm));
    }
    setCheckExistingNeed(false);
    dispatch(setSearchPopUp(true));
    dispatch(setEngagedCouple(0));
  };

  const handleGroupCall = async (ad) => {
    const ID = ad?.Id;
    const phoneDetailsObj = [
      {
        email: ad?.Email,
        phoneNumber: ad?.Phone,
        countryCode: ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.alternativePhoneOne,
        countryCode:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.alternativePhoneTwo,
        countryCode:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: user?.Email,
        phoneNumber: user?.Phone,
        countryCode: user?.CountryCode,
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: user?.Email,
      userTo: ad?.createdBy,
      userFrom: user?.UserID,
      callType: 1, //1 for phone,2 for voip,3 for zoom
      userToPhone: phoneDetails,
      userFromPhone: `${user?.CountryCode}${user?.Phone}`,
      typeId: ad?.Id,
      Type: "need",
    };
    toast.success("Group Call send to your Mobile please respond");
    await initiateCall(formData);
  };
  console.log("ad", ad);
  return (
    <>
      {ad.engagedCouple == 1 && (
        <div className="w-100 text-center engagedCouple">
          {user?.UserID != ad.createdBy && (
            <>
              {isAdInMyOffers(ad) ? (
                <>
                  <span className="dropdown-center position-relative">
                    <Button
                      color="success"
                      size="sm"
                      className="dropdown-toggle w-100 mb-2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      disabled={checkExistingNeed}
                    >
                      {checkExistingNeed ? (
                        <Spinner size="sm" color="light" className="me-2" />
                      ) : null}
                      Call Me
                    </Button>
                    <ul
                      className="dropdown-menu dropdown-menu-center"
                      style={{ cursor: "pointer" }}
                    >
                      <li>
                        <a
                          className="dropdown-item text-center fw-bold"
                          onClick={() => handleIndiviualCall(ad)}
                        >
                          Individual Call <FaUser />
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item text-center fw-bold"
                          onClick={() => handleGroupCall(ad)}
                        >
                          Group Call <MdGroups size={20} />
                        </a>
                      </li>
                    </ul>
                  </span>
                  <Button
                    color="primary"
                    size="sm"
                    className="w-100 mb-2"
                    onClick={(event) => handleAction(event, "TEXT")}
                    disabled={checkExistingNeed}
                  >
                    {checkExistingNeed ? (
                      <Spinner size="sm" color="light" className="me-2" />
                    ) : null}
                    Send message
                  </Button>
                </>
              ) : isAlreadyGotton(ad) ? (
                <Button
                  color="primary"
                  size="xs"
                  className="w-100 mb-2"
                  disabled
                >
                  Other venues took customer
                </Button>
              ) : +gottonData?.totalMessages >=
                +gottonData?.getCustomerLimit ? (
                <Button className="w-100 mb-2" color="primary" disabled>
                  Monthly Limit Exceeded
                </Button>
              ) : (
                <>
                  <Button
                    color="primary"
                    size="sm"
                    className="w-100 mb-2"
                    onClick={(event) => openOfferModal(event, ad)}
                    disabled={checkExistingNeed}
                  >
                    {checkExistingNeed ? (
                      <Spinner size="sm" color="light" className="me-2" />
                    ) : null}
                    Get Customer!
                    <br />
                    {islogin && (
                      <>
                        {timeLeft === "00:00:00" ? (
                          <p
                            className="text-white m-0 text-nowrap"
                            style={{ fontSize: "12px" }}
                          >
                            Late Fee $10
                          </p>
                        ) : (
                          <div className="d-flex align-items-center justify-content-center">
                            <p
                              className="m-0"
                              style={{
                                fontSize: "small",
                                color: "white",
                                textWrap: "nowrap",
                              }}
                            >
                              {timeLeft === "00:00:00"
                                ? `Time's Up: ${timeLeft}`
                                : `Time left: ${timeLeft}`}
                            </p>
                            <button
                              id="ScheduleUpdateTooltip"
                              ref={buttonRef}
                              className="ms-2 position-relative"
                              style={{
                                backgroundColor: "inherit",
                                color: "white",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setTimeout(() => {
                                  dispatch(setTooltipOpen(true));
                                }, 0);
                              }}
                            >
                              <BsInfoCircleFill size={17} />
                            </button>
                            <UncontrolledTooltip
                              placement="top"
                              target="ScheduleUpdateTooltip"
                              trigger="click"
                              isOpen={tooltipOpen}
                              toggle={() => dispatch(setTooltipOpen(false))}
                              container="body"
                              innerRef={tooltipRef}
                            >
                              Free during 24-hour timer, $10 late fee applies
                              after
                            </UncontrolledTooltip>
                          </div>
                        )}
                      </>
                    )}
                  </Button>
                  {(isVendor || isAdmin) && (
                    <Button
                      color={ad?.needSkipCustomer == 1 ? "secondary" : "danger"}
                      size="sm"
                      className="w-100 mb-2"
                      onClick={(e) => handleSkip(e, ad)}
                      disabled={checkExistingNeed}
                    >
                      {checkExistingNeed ? (
                        <Spinner size="sm" color="light" className="me-2" />
                      ) : null}
                      {ad?.needSkipCustomer == 1 ? "Unskip" : "Skip"}
                    </Button>
                  )}
                </>
              )}
            </>
          )}
          <Button
            color={questionsVisible[ad.Id] ? "secondary" : "warning"}
            size="sm"
            className="w-100 mb-2"
            onClick={(event) => toggleQuestions(event, ad)}
            disabled={checkExistingNeed}
          >
            {checkExistingNeed ? (
              <Spinner size="sm" color="light" className="me-2" />
            ) : null}
            {questionsVisible[ad.Id] ? "Hide Q&A" : "Show Q&A"}
          </Button>
          <Button
            color={eventsVisible[ad.Id] ? "secondary" : "success"}
            size="sm"
            className="w-100 mb-2"
            onClick={(event) => toggleEvents(event, ad)}
            disabled={checkExistingNeed}
          >
            {checkExistingNeed ? (
              <Spinner size="sm" color="light" className="me-2" />
            ) : null}
            {eventsVisible[ad.Id] ? "Hide Event Details" : "Show Event Details"}
          </Button>
          {isAdmin && (
            <Button
              color="info"
              size="sm"
              className="w-100 mb-2"
              onClick={(event) => handleRecomend(event, ad)}
              disabled={checkExistingNeed}
            >
              {checkExistingNeed ? (
                <Spinner size="sm" color="light" className="me-2" />
              ) : null}
              Recomend
            </Button>
          )}
        </div>
      )}
      {ad.engagedCouple != 1 &&
      user?.UserID != ad.createdBy &&
      ad?.checkedValue === "mobile" ? (
        <div className="w-100 text-center need">
          <button
            className="btn btn-success btn-sm mb-2 w-100"
            onClick={(event) => handleAction(event, "CALL")}
            disabled={checkExistingNeed}
          >
            {checkExistingNeed ? (
              <Spinner size="sm" color="light" className="me-2" />
            ) : null}
            {phoneButton}
          </button>
          <Button
            color="primary"
            size="sm"
            className="w-100 mb-2"
            onClick={(event) => handleAction(event, "TEXT")}
            disabled={checkExistingNeed}
          >
            {checkExistingNeed ? (
              <Spinner size="sm" color="light" className="me-2" />
            ) : null}
            Send Message
          </Button>
          {isAdmin && ad.engagedCouple == 1 && (
            <Button
              color="info"
              size="sm"
              className="w-100 mb-2"
              onClick={(event) => handleRecomend(event, ad)}
              disabled={checkExistingNeed}
            >
              {checkExistingNeed ? (
                <Spinner size="sm" color="light" className="me-2" />
              ) : null}
              Recomend
            </Button>
          )}
        </div>
      ) : (
        ad.engagedCouple != 1 &&
        ad?.checkedValue === "website" &&
        user?.UserID != ad.createdBy && (
          <button
            className={`btn btn-sm`}
            style={{ backgroundColor: "#99d9ea" }}
            onClick={(event) => handleAction(event, "VISIT")}
            disabled={checkExistingNeed}
          >
            {checkExistingNeed ? (
              <Spinner size="sm" color="dark" className="me-2" />
            ) : null}
            <a
              // target="_blank"
              className="text-dark"
              style={{
                fontSize: "15px",
                fontWeight: "600",
                padding: "3px 7px",
              }}
            >
              Visit Webpage
            </a>
          </button>
        )
      )}
    </>
  );
};

export default LcaActionButtons;
